<template>
  <div>
    <button-gutter>
      <router-link :to="'/invoice-apply/update/'+scope.row.id"
                   v-if="(scope.row.status === 3 || scope.row.status === 1) && parseInt(user.id) === scope.row.initiator"
      >
        <el-button type="primary"
                   size="mini">修改
        </el-button>
      </router-link>


        <el-button type="danger"
                   size="mini"
                   v-if="[1, 3].includes(parseInt(scope.row.status)) && parseInt(user.id) === parseInt(scope.row.initiator)"
                   @click="abandonInvoice(scope.row.id)">放弃
        </el-button>


        <el-button type="warning"
                   size="mini"
                   v-if="scope.row.status === 1 && parseInt(user.id) === scope.row.bu_approver"
                   @click="approveInvoice(scope.row.id)">BO审批
        </el-button>

        <el-button type="success"
                   size="mini"
                   v-if="scope.row.status === 6 && parseInt(user.id) === scope.row.initiator"
                   @click="confirmInvoice(scope.row.id)">客户签收
        </el-button>

        <el-button type="danger"
                   size="mini"
                   v-if="isShowReturnBtn(scope.row)"
                   @click="returnInvoice(scope.row.id)">申请退票
        </el-button>

    </button-gutter>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  props: {
    scope: Object,
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
    }),
  },
  methods: {
    approveInvoice (id) {
      this.$emit('approveInvoice', Object.assign({}, this.params, {id: id}))
    },
    confirmInvoice (id) {
      this.$emit('confirmInvoice', Object.assign({}, this.params, {id: id}))
    },
    returnInvoice (id) {
      this.$emit('returnInvoice', Object.assign({}, this.params, {id: id}))
    },
    abandonInvoice (id) {
      this.$emit('abandonInvoice', Object.assign({}, this.params, {id: id}))
    },
    isShowReturnBtn (item) {
      // 已开票，已签收状态，且发起人 显示退票按钮
      return [6, 7].includes(item.status * 1) && item.initiator * 1 === this.user.id * 1
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/OperationButtons.vue